// ABOUTME: Selects the company responders for company-routed pre-registration.
// ABOUTME: Keeps unavailable configured users visible until an administrator removes them.
import React from "react";
import {
    Checkbox,
    FormControl,
    InputLabel,
    ListItemText,
    MenuItem,
    Paper,
    Select,
    Typography
} from "@material-ui/core";

import { WhatsappPreRegistrationLabels } from "./whatsappPreRegistrationLabels";
import {
    WhatsappPreRegistrationConfig,
    WhatsappPreRegistrationOptions
} from "./whatsappPreRegistrationSettingsModel";

interface WhatsappPreRegistrationCompanyResponderEditorProps {
    config: WhatsappPreRegistrationConfig;
    users: WhatsappPreRegistrationOptions["users"];
    labels: WhatsappPreRegistrationLabels;
    onChange: (config: WhatsappPreRegistrationConfig) => void;
}

const getSelectValues = (value: unknown) =>
    (Array.isArray(value) ? value : String(value || "").split(","))
        .map((item) => String(item || "").trim().toLowerCase())
        .filter(Boolean);

const WhatsappPreRegistrationCompanyResponderEditor = ({
    config,
    users,
    labels,
    onChange
}: WhatsappPreRegistrationCompanyResponderEditorProps) => (
    <Paper elevation={0} style={{ padding: 24 }}>
        <Typography variant="h6" gutterBottom>
            {labels.companyResponders}
        </Typography>
        <Typography variant="body2" color="textSecondary">
            {labels.companyRespondersHelp}
        </Typography>
        <FormControl fullWidth variant="outlined" margin="normal">
            <InputLabel>{labels.companyResponders}</InputLabel>
            <Select
                multiple
                value={config.companyUserEmails}
                onChange={(event) =>
                    onChange({
                        ...config,
                        companyUserEmails: getSelectValues(event.target.value)
                    })
                }
                label={labels.companyResponders}
                renderValue={(selected) =>
                    getSelectValues(selected)
                        .map(
                            (email) =>
                                users.find((user) => user.email === email)
                                    ?.name || email
                        )
                        .join(", ")
                }
            >
                {users.map((user) => (
                    <MenuItem key={user.email} value={user.email}>
                        <Checkbox
                            checked={config.companyUserEmails.includes(
                                user.email
                            )}
                        />
                        <ListItemText
                            primary={`${user.name}${
                                user.available === false
                                    ? ` (${labels.unavailable})`
                                    : ""
                            }`}
                        />
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    </Paper>
);

export default WhatsappPreRegistrationCompanyResponderEditor;
